import axios from '@/plugins/axios';

const NEWS = '/news';
export async function getNews(page) {
  try {
    const { data } = await axios.get(NEWS, { params: { page } });
    return data;
  } catch (err) {
    return { err };
  }
}
export async function getNewDetail(id) {
  try {
    const { data } = await axios.get(`${NEWS}/${id}`);
    return data;
  } catch (err) {
    return { err };
  }
}
export async function getNewsTab(payload) {
  const { tab, page } = payload;
  try {
    const { data } = await axios.get(`${NEWS}?category_id=${tab}&page=${page}`);
    return data;
  } catch (err) {
    return { err };
  }
}
export async function getAllNews() {
  try {
    const { data } = await axios.get(NEWS);
    return data;
  } catch (err) {
    return { err };
  }
}
